import { FlatRatePlan } from "@common/schemas/billing.schema";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { FC } from "react";
import { Plans, PlansProps } from "../Plans/Plans";

interface Props {
    plans: FlatRatePlan[];
    renderAction?: PlansProps["renderAction"];
    renderPrice: PlansProps["renderPrice"];
}

export const PlansOverviewModal: FC<Props> = ({
    plans,
    renderAction,
    renderPrice,
}) => (
    <>
        <StandardModalHeader>Plans</StandardModalHeader>
        <StandardModalBody className="overflow-y-auto">
            <Plans
                stickyHeaders
                plans={plans}
                renderAction={renderAction}
                renderPrice={renderPrice}
            />
        </StandardModalBody>
    </>
);
